export const SWITCH_COLOR = '@SWITCH_COLOR';

export const actionCreators = {
    switchColor: () =>  ({ type: SWITCH_COLOR }),
};
